export default function () {
    const badgeCaseData = [
        {
            company: {
                companyId: 1,
                logoUrl: require('@/assets/png/badgeCompany/company-1/company-logo.png'),
                name: '宏恩塑膠股份有限公司',
                introduction:
                    '宏恩創立於1980年，已擁有超過40年的再生塑膠處理經驗及專業技術。年處理量從草創之初700噸，擴增至目前每年可有效處理5萬噸以上。業務範圍為PP、PE、ABS、PS、PC、PET(紗、片)等新舊料買賣\n\
                    \n\
                    近年，海廢問題嚴重，而宏恩身為資源回收再利用業者，於2019年開始投入解決台灣不易處理的海洋廢棄物，包括漁網、漁業浮筒、保麗龍、瓶罐塑膠等等。\n\
                    \n\
                    進入宏恩的再生廠後，通過品質檢測，再經過清洗、分類、及熔融，最後產出100%的海廢再生塑膠粒。\n\
                    \n\
                    經驗證的海廢再生塑膠材質包括：PP、PE、PA、ABS及PS。\n\
                    \n\
                    針對不同特性的塑膠，開發出多種用途的再生料，涵蓋吹瓶級、吹袋級、押出級與射出級等，且提供客製化配料與染色服務。\n\
                    \n\
                    宏恩產出的再生塑膠品質達90%媲美新料等級，可應用於各類瓶罐、袋子、家用產品、建材、電子產品、辦公用品、汽車零部件以及運動用品等等多種選擇。\n\
                    \n\
                    宏恩本著初衷：「誠信、務實、責任、創新」，在最不起眼的地方，堅持做對地球有益的事，全心推廣循環經濟，賦予再生塑膠更高的價值。',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-1.jpeg'),
                            name: '海廢PP塑膠再生料',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-2.jpeg'),
                            name: '海廢PE塑膠再生料',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-3.jpeg'),
                            name: '海廢PA膠再生料',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-4.jpeg'),
                            name: '海廢ABS塑膠再生料',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-5.jpeg'),
                            name: '海廢PS塑膠再生料',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 2,
                logoUrl: require('@/assets/png/badgeCompany/company-2/company-logo.png'),
                name: '寶綠特資源再生科技股份有限公司',
                introduction:
                    '於1991年在台灣成立聚酯回收清洗廠，已累積20年PET及其它塑料瓶回收處理和15年聚酯短纖生產經驗，致力於塑料回收技術研究開發及再生物資綜合利用，並逐步邁向 「再生聚酯產業鏈資源與技術整合者」之目標。\n\
                    我們豐富的製造經驗成為我們規劃、設計與製造塑料環保機械的最大支柱。尤其在 PET 瓶再生回收的領域上，除提供整廠輸出或單一設備之技術外，也實際營運再生PET、PP各類原料及上下游產品之製造、銷售。',
            },
            cases: [
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 1 收集清運',
                                    content: '為確保海廢來源，需串連企業及淨灘團體等從寶特瓶收集開始。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/step-1.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 2 清洗破碎',
                                    content:
                                        '寶特瓶(PET)回收後，需經過清洗、粉碎、吹標等多道程序，產出乾淨的海廢PET碎片，由於海廢寶特瓶經過日曬及海水浸泡，損耗率較一般回收寶特瓶高出許多。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/step-2.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 3 造粒',
                                    content:
                                        'PET碎片經乾燥及熔融擠出造粒，由於回收可再利用海廢寶特瓶數量較陸少，且品質不穩定，需和非海廢寶特瓶混合使用製成50%海廢重量比例，以利後續適用',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/step-3.jpg'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/product-1.jpeg'),
                            name: '海廢PET破碎瓶片',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/product-2.jpeg'),
                            name: '海廢PET瓶粒',
                            wasteProportion: 50,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/product-3.jpeg'),
                            name: '海廢PP破碎瓶片',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 3,
                logoUrl: require('@/assets/png/badgeCompany/company-3/company-logo.png'),
                name: '台捷精密股份有限公司',
                introduction:
                    '台捷公司使用寶綠特之海廢標章產品PET粒，並添加農業廢棄物-稻殼粒與漁業廢棄物-蚵殼粉，混合再生粒料以申請標章，並進而製作建材-板材、角材及拼接地板。合計共有4項產品取得標章。',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-1.png'),
                            name: '海捷晶粒料（PET）',
                            wasteProportion: 25,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-2.png'),
                            name: '板材（PET）',
                            wasteProportion: 21.93,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-3.png'),
                            name: '角材（PET）',
                            wasteProportion: 21.93,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-4.png'),
                            name: '模組拼接地板（PET）',
                            wasteProportion: 21.67,
                        },
                    ],
                },
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 1 原料',
                                    content: '以合作夥伴產出之已取得環境部海洋廢棄物循環產品標章、海廢含量100%的浮球再生粒子為原料進行生產。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-2/step-1.png'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 2 烘料、混料',
                                    content: '將海廢浮球再生粒子與其他原料進行烘乾後，以一定比例搭配、攪拌，並進行投料。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-2/step-2.png'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 3 塑木板材押出',
                                    content: '控制溫度與壓力並透過模具，押出生產塑木板材。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-2/step-3.png'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-2/product-1.png'),
                            name: '海捷晶板',
                            wasteProportion: 21.9,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 4,
                logoUrl: require('@/assets/png/badgeCompany/company-4/company-logo.png'),
                name: '耐斯企業股份有限公司',
                introduction:
                    '耐斯公司向宏恩塑膠公司採購經環保署核發標章之『100%PE海廢再生塑膠粒』，並依最終產品物性需求調配為26%PE海廢再生塑膠粒，加上74%消費後再生塑膠，送至集泉塑膠公司進行「中空吹瓶成型」作業。\n\
                    \n\
                    完成後的空瓶，交付耐斯公司進行白鴿漂白素內料充填作業。海洋富含人類需要的食鹽(NaCl)，食鹽水經過電解後，可產生氫氧化鈉(NaOH)。當氫氧化鈉再與二氧化碳(CO2)反應時，可產出碳酸鈉(Na2CO3)或碳酸氫鈉(NaHCO3)。\n\
                    \n\
                    而碳酸鈉與過氧化氫(H2O2即雙氧水)反應後，製成過碳酸鈉(SPC)產品，可用作洗衣助劑，且具有氧系漂白功效。白鴿漂白素(內容物富含SPC)係屬來自海洋的超級環保且兼具清潔、殺菌之洗滌劑。\n\
                    \n\
                    如今再加上外包裝容器(瓶身)係採100%回收再生塑料製成，從裡到外，則完全是天然環保，循環再利用的好商品。',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-4/case-1/product-1.jpeg'),
                            name: '白鴿漂白素瓶身',
                            wasteProportion: 26,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 5,
                logoUrl: require('@/assets/png/badgeCompany/company-5/company-logo.png'),
                name: '海神全球股份有限公司',
                introduction:
                    '海神全球透過化學性回收之熱裂解技術，我們將回收的廢塑膠化學性處理轉換成新的再生油品與再生碳：燃料油，熱裂解油及再生碳。油品可用於再生塑膠源料，燃油使用等。再生碳也可用於傳統碳黑可使用的用途。這是解決日積月累的塑膠垃圾和空汙問題的最佳方式。我們是少數能透過化學性回收-熱裂解技術達成高轉換率並達到低排放減碳排，對環境極低負擔的公司。\n\
                    海神PSD再生碳為百分百回收料製成。其中包含近4成的海廢漁網，與超過6成的廢塑膠。此再生碳用途廣汎，不止是可用於碳鋼製造，泊油路，更可用於上色的其他用途。采用此產品可幫助減少海廢與鼓勵更多廠商與政府機關去做更多回收海廢的活動，推動台灣海洋廢棄物循環再利用，領先全球！',
            },
            cases: [
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 1 收集清運',
                                    content: '透過政府標案取得海洋廢棄物漁網。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-5/case-1/step-1.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 2 清洗',
                                    content: '回收漁網後需要經過人工清洗。',
                                },
                                {
                                    title: '海廢再生 STEP 3 破碎',
                                    content: '清洗後的漁網，有許多複雜異材質，需由人工去除雜質及破碎才能再利用，因此每批漁網需耗時至少1~2周的時間。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-5/case-1/step-2.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 4 熱裂解',
                                    content: '透過化學性回收-熱製程轉換技術，將抽料槽的原料(漁網/Nylon)抽至平台進入供料槽後至裂解爐區進行裂解後產出PSD再生碳(產品)。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-5/case-1/step-3.jpg'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-5/case-1/product-1.jpeg'),
                            name: '海神PSD再生碳',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 6,
                logoUrl: require('@/assets/png/badgeCompany/company-6/company-logo.png'),
                name: '綠藤生物科技股份有限公司',
                introduction:
                    '關於綠藤生機\n\
                    \n\
                    成立於 2010 年的綠藤生機，以「二減一加」的深入減法的純淨保養 — 減去非必要程序、減去超過 2,900 種非必要成分，加上必要的透明，挑戰保養慣例。從洗沐到臉部保養僅 22 款產品，讓每天的保養，成為肌膚與環境永續的可能。綠藤也是亞洲唯一、連續五度獲得「對世界最好（Best for the World）」環境面項大獎的 B 型企業。\n\
                    頭皮淨化洗髮精 海廢再生瓶\n\
                    \n\
                    2022 年初，綠藤展開了一場挑戰：希望讓更多台灣在地的廢棄漁網進入回收再生循環、減少海洋負擔 ……\n\
                    耗時半年、串連 5 家供應鏈夥伴投入，終於使來自從台中梧棲港蒐集的 1,800 公斤的廢棄漁網，獲得第二生命，再次循環利用。\n\
                    「頭皮淨化洗髮精 海廢再生瓶」瓶器不僅由 100% 再生塑膠、高比例 33% 海洋廢棄物製成，並於 10 月獲得了環保署認證「海洋廢棄物循環產品標章」，第一支來自台灣的海廢再生洗髮精誕生！',
            },
            cases: [
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 1 清洗、去化',
                                    content: '回收漁網，會有許多異材質，例如浮子、鉛塊、鉛線等，需要經過人工清洗、去化雜質後，才能再利用。',
                                },
                                {
                                    title: '海廢再生 STEP 2 破碎',
                                    content: '清潔後的漁網，必須交由「破碎廠」破碎為小塊狀，也藉此能讓破碎漁網的水分蒸發、排出，並濾除殘留的泥沙、雜質。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-6/case-1/step-1.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 3 造粒',
                                    content: '破碎漁網經過高溫熔融，經測試穩定度達到標準後，再抽絲、造粒，將再生塑膠製成顆粒狀，以便後續加工。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-6/case-1/step-2.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生 STEP 4 混練',
                                    content: '受限於 100% 的海廢再生塑膠粒，穩定性較不佳，必須和其他再生塑膠混練使用。',
                                },
                                {
                                    title: '海廢再生 STEP 5 吹瓶',
                                    content:
                                        '確認材料比例後，吹瓶廠將再生塑膠粒融化、吹塑成瓶狀。而綠藤的供應鏈廠商皆是第一次嘗試海廢再生材料，過程因塑膠粒水氣、雜質等多項材料先天問題，讓吹瓶參數設定挑戰不少，再多次失敗後，新增了乾燥的作業流程，也透過多次製程調整，找出適合的溫度。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-6/case-1/step-3.jpg'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-6/case-1/product-1.jpeg'),
                            name: '頭皮淨化洗髮精 海廢再生瓶',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 7,
                logoUrl: require('@/assets/png/badgeCompany/company-7/company-logo.png'),
                name: '豐溢綠能材料股份有限公司',
                introduction:
                    '豐溢綠能材料是專門生產消費後回收再生塑膠以及海洋廢棄回收再生塑膠粒的公司，並提供材料改性複合和配色服務。我們從塑膠容器回收處理廠起家，能提供長期穩定的消費後材料，並透過專業的分選、清洗及色選技術，生產出高品質、低氣味、淺色的再生塑膠粒。我們的PCR產品皆取得GRS溯源認證、TÜV產品碳足跡認證以及TÜV溯源認證，並通過第三方檢測公司的REACH、ROHS及FDA TEST測試通過。能客製化開發PCR材料以及提供客戶材料需求的完整解決方案是我們最大的特色及優勢。',
            },
            cases: [
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: 'STEP 1 收集、分類',
                                    content: '海廢漁網多為PA、HDPE、PP材質混雜，我們通過專業師傅的人工挑選後，將HDPE海廢漁網分類出來。',
                                },
                                {
                                    title: 'STEP 2 清洗、粉碎',
                                    content:
                                        '海廢漁網因長期浸泡在海水中，夾雜許多鹽分及異材質，例如浮球、鉛線、垃圾等，透過人工清洗將鹽分及異材質去除，才能生產出高品質的海廢再生粒。清洗好的漁網在用專用的破碎機進行粉碎，將整片的漁網瘦身成小塊狀，才能完整入料生產。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-1/step-1.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP 3 再生造粒',
                                    content: '粉碎後的漁網需先經過攪拌桶拌料後在進到造粒設備，經過三道濾網過濾雜質，透過高溫熔融後產出100%的海廢再生粒子。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-1/step-3.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP 4 混煉造粒',
                                    content: '100%海廢PE再生粒可依據客戶產品需求，由豐溢綠能材料的研發中心進行材料混煉開發，提供符合客戶製程需求的海廢產品原料。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-1/step-4.jpg'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-1/product-1.jpg'),
                            name: '100%海廢 PE漁網再生粒子',
                            wasteProportion: 100,
                        },
                    ],
                },
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: 'STEP 1 減容回收',
                                    content:
                                        '保麗龍箱因為蓬鬆導致運輸成本高昂，所以必須經過減容後才能運回廠內進行再利用處理。傳統的減容方式為加熱法或冷壓法，此方式會讓海廢保麗龍中的雜質(藤壺、鹽分、垃圾等)濃縮進行，導致再生粒子品質不佳。豐溢綠能材料擁有專利的減容回收設備，透過藥劑法回收進行減容，將海廢保麗龍還原成液態狀儲存。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-2/step-1.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP 2 蒸餾萃取',
                                    content:
                                        '海廢保麗龍液經由專利的萃取設備，透過蒸餾方式將PS液、雜質及藥劑做分離，如此可去除95%以上的海廢雜質；同時這些藥劑又有95%以上能被回收重新循環使用。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-2/step-2.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP 3 生成融塊、粉碎',
                                    content: '萃取出來的PS液經由設備生成PS融塊，接著進行粉碎變成海廢PS再生粒原料。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-2/step-3.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP 4 再生造粒',
                                    content: '粉碎後的海廢PS碎片需先經過攪拌桶拌料後在進到造粒設備，經過三道濾網過濾雜質，透過高溫熔融後產出100%的海廢再生粒子。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-2/step-4.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP 5 混煉造粒',
                                    content: '100%海廢PS再生粒可依據客戶產品需求，由豐溢綠能材料的研發中心進行材料混煉開發，提供符合客戶製程需求的海廢產品原料。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-2/step-5.jpg'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-2/product-1.jpg'),
                            name: '100%海廢 保麗龍再生粒子',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 8,
                logoUrl: require('@/assets/png/badgeCompany/company-8/company-logo.png'),
                name: '益鈞環保科技股份有限公司',
                introduction:
                    '益鈞環科創立源自於母公司益州集團之理念，以「環境永續」為經營目標。益州集團多年來默默不斷執行各項循環經濟相關產業，如廢棄油品、廢玻璃等再利用，均不斷尋求各種資源永續的環境友善方式。\n\
                    \n\
                    益鈞環科制定了一套完善的循環再利用方案，讓尿布廢棄物的終點重新給予活化契機，也同時投入海洋環境保護，透過整合海廢回收、再生處理，促進資源的共享、技術的交流和共同應對海洋垃圾的努力，串連了上下游產業鍊，實證了還原材料再製的各項案例。',
            },
            cases: [
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: '海廢再生STEP 1 收集清運',
                                    content: '桃園市政府雇工廠商定期於海岸淨灘，撿拾、收集海廢浮球。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-8/case-1/step-1.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生STEP 2 前處理',
                                    content:
                                        '浮球於使用上會搭配繩索進行綑綁，而長時間浸泡於海水中易吸附鹽分並且有生物附著其上生長，如牡蠣、藤壺與海草等，皆需去除與清洗後才可進行後續再利用。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-8/case-1/step-2.jpg'),
                        },
                        {
                            articles: [
                                {
                                    title: '海廢再生STEP 3 破碎、造粒',
                                    content: '黑色海廢浮球經破碎、高溫熔融後擠出造粒，可產出海廢含量100%的浮球再生粒子。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-8/case-1/step-3.jpg'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-8/case-1/product-1.jpg'),
                            name: '海廢浮球再生粒子',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 9,
                logoUrl: require('@/assets/png/badgeCompany/company-9/company-logo.png'),
                name: '益鈞環保科技股份有限公司',
                introduction:
                    '益鈞環科創立源自於母公司益州集團之理念，以「環境永續」為經營目標。益州集團多年來默默不斷執行各項循環經濟相關產業，如廢棄油品、廢玻璃等再利用，均不斷尋求各種資源永續的環境友善方式。\n\
                    \n\
                    益鈞環科制定了一套完善的循環再利用方案，讓尿布廢棄物的終點重新給予活化契機，也同時投入海洋環境保護，透過整合海廢回收、再生處理，促進資源的共享、技術的交流和共同應對海洋垃圾的努力，串連了上下游產業鍊，實證了還原材料再製的各項案例。',
            },
            cases: [
                {
                    story: [
                        {
                            articles: [
                                {
                                    title: 'STEP1 浮球、浮標離島清運',
                                    content:
                                        '海水湛藍沙灘一望無際，每到東北季風南下自澎湖，大量海洋廢棄浮球堆置在沙灘各地。澎湖是臺灣群島縣市，也是海洋廢棄物相當嚴重地區之一。澎湖當地透過淨灘活動，所撿拾的海漂廢棄物裝載運送至清潔隊儲存轉運至台灣焚燒去化處理。由於體積龐大當地除了僅採裝置藝術就地活化，但一段時期一過還是最終成為廢棄物。澎湖離島廢棄物去化運輸成本高昂需仰賴台灣本島焚燒去化。因此透過公私夥伴合作結合循環經濟概念與澎湖縣湖西清潔隊示範合作從澎湖清運至本島進行再利用示範處理。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/step-1.png'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP2 破碎',
                                    content: '將浮球分色後進行清洗破碎至5mm以下。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/step-2.png'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP3材料混合(改質粒製程)',
                                    content: '依據客戶產品需求，加入黏著劑及其他混合材料進行開發，提供符合客戶製程需求的海廢產品。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/step-3.png'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP3 異型押出',
                                    content: '透過押出機將海廢造粒搭配不同的模具及後段冷卻定型設備，生產各類海廢板材。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/step-4.png'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP4加工裁切',
                                    content: '依客戶需求設計產品圖樣，裁切板材提供符合客戶製程需求的海廢產品。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/step-5.png'),
                        },
                        {
                            articles: [
                                {
                                    title: 'STEP5產品組裝',
                                    content: '依客戶需求將裁切板材提供符合客戶製程需求的海廢產品組裝成產品。',
                                },
                            ],
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/step-6.png'),
                        },
                    ],
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-1.jpg'),
                            name: '100%海廢再生塑膠粒',
                            wasteProportion: 40,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-2.jpg'),
                            name: '100%海廢角板材-psce10',
                            wasteProportion: 24.75,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-3.jpg'),
                            name: '海廢角板材-psce9',
                            wasteProportion: 24.75,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-4.jpg'),
                            name: '海廢角板材-psce7',
                            wasteProportion: 24.75,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-5.jpg'),
                            name: '海廢角板材-psce6',
                            wasteProportion: 24.75,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-6.jpg'),
                            name: '海廢角板材圓棒',
                            wasteProportion: 24.75,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-7.jpg'),
                            name: '海廢循環展架',
                            wasteProportion: 24.38,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-9/case-1/product-8.jpg'),
                            name: '海廢置物箱',
                            wasteProportion: 24.36,
                        },
                    ],
                },
            ],
        },
    ]
    return { badgeCaseData }
}
